import { render, staticRenderFns } from "./translateDialogue.vue?vue&type=template&id=9f649986&scoped=true"
import script from "./translateDialogue.vue?vue&type=script&lang=js"
export * from "./translateDialogue.vue?vue&type=script&lang=js"
import style0 from "./translateDialogue.vue?vue&type=style&index=0&id=9f649986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f649986",
  null
  
)

export default component.exports